import React from "react";

const SecondaryBtn = ({
  btnName = "secondary btn",
  clickEvent,
  btnType,
  extraClass,
}) => {
  return (
    <button
      type={btnType}
      onClick={clickEvent}
      className={` justify-center
        w-full max-w-[350px] h-[50px]  cusror-pointer bg-[#FF6943]/10 hover:bg-[#FF6943] transition-all ease-in-out duration-300 w-[350px] p-2 rounded-full text-center text-[#FF6943] hover:text-white border border-[#FF6943] ${extraClass}`}
    >
      {btnName}
    </button>
  );
};

export default SecondaryBtn;
